import { SectionTitle } from '../../globalStyles'
import {
  SocialsContainer,
  SocialsDiv,
  SocialIcon,
  Form,
  Input,
  Label,
  InputTextArea
} from './SocialSections.elements'
import github from '../../assets/social-icons/github.svg'
import twitter from '../../assets/social-icons/twitter.svg'
import linkedin from '../../assets/social-icons/linkedin.svg'
import dribbble from '../../assets/social-icons/dribbble.svg'
import { useState } from 'react'

const SocialsSection = () => {
  return (
    <SocialsContainer id="connect-section">
      <SectionTitle>
        <h3>SOCIALS</h3>
      </SectionTitle>

      <SocialsDiv>
        <a
          href="https://twitter.com/tarun_soni_"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={twitter} alt="twitterIcon" />
        </a>
        <a
          href="https://github.com/tarun-soni"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={github} alt="githubIcon" />
        </a>
        <a
          href="https://linkedin.com/in/tarun-b-soni/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={linkedin} alt="linkednIcon" />
        </a>
        <a
          href="https://dribbble.com/tarun_soni"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={dribbble} alt="dribbbleIcon" />
        </a>
      </SocialsDiv>

      <SectionTitle style={{ marginTop: '2rem' }}>
        <h4>CONTACT ME</h4>
      </SectionTitle>
      <ConnectForm />
    </SocialsContainer>
  )
}

export default SocialsSection

function ConnectForm() {
  const [name, setName] = useState()
  const [email, setEmail] = useState()
  const [message, setMessage] = useState()

  const onInputChange = (e) => {
    const { name, value } = e.target
    switch (name) {
      case 'name':
        setName(value)
        break
      case 'email':
        setEmail(value)
        break
      case 'message':
        setMessage(value)
        break
      default:
        break
    }
  }

  return (
    <form name="contact-form" method="post">
      <Form>
        <input type="hidden" name="form-name" value="contact-form" />
        <Label htmlFor="name">Name</Label>
        <Input
          type="text"
          name="name"
          id="name"
          value={name}
          onChange={onInputChange}
        />
        <Label htmlFor="email" type="email">
          Email
        </Label>{' '}
        <Input
          type="email"
          name="email"
          value={email}
          onChange={onInputChange}
        />
        <Label htmlFor="message">Any Message?</Label>
        <InputTextArea
          name="message"
          value={message}
          onChange={onInputChange}
        />
        {console.log('name', name)}
        {console.log('email', email)}
        {console.log('message', message)}
        {name && email && message ? (
          <Input
            style={{ margin: '1.25rem auto', border: '2px solid' }}
            type="submit"
            value="SEND"
          />
        ) : (
          <Input
            style={{ margin: '1.25rem auto' }}
            type="submit"
            value="SEND"
            disabled
          />
        )}
      </Form>
    </form>
  )
}
